import { Relation } from '@nemuru-eng/js-api-client';

import { Text } from '@/components/shared/components/Text';

export const RelationOptions = Object.values(Relation).map((value) => ({
  value,
  display: <Text tId={value} />,
}));
